export default "__VITE_ASSET__WMUb1KzR__"